import React, { useEffect, useState } from "react";
import { signOut } from "aws-amplify/auth";
function LogoutPage() {
    useEffect(() => {
       handleLogout();
      }, []);
    const handleLogout = async () => {
        try {
          await signOut();
          localStorage.removeItem("user"); // Remove the user key from localStorage
          window.location.href = "/login"; // Redirect to the login page
        } catch (error) {
          console.error("Error signing out: ", error);
        }
      };
  return (
    <div>
      
    </div>
  )
}

export default LogoutPage
